import { cn } from "@/ui/lib";
import { BASE_TEXT_BODY_SIZE_CLASS_MAP } from "../typography/TextBody";
import type { TSelectOption } from "@/ui/components/form/Select";


/*-------------------------------------
|  Constants
|-------------------------------------*/

export const BASE_INPUT_CLASSES = cn(
  "peer w-full box-border rounded-sys-sm border border-solid",
  "border-component-input-default bg-component-input-default shadow-sm",
  "placeholder:text-foreground-muted disabled:text-foreground-muted font-sys-default",
  "focus:outline focus:outline-1 focus:outline-offset-0 focus:outline-sys-black",
  "focus:ring-4 focus:ring-focus-primary focus:bg-component-input-focused",
  "[&:not(:placeholder-shown)]:bg-component-input-focused",
  BASE_TEXT_BODY_SIZE_CLASS_MAP[2],
);

export const INPUT_ERROR_CLASSES =
  "border-component-input-destructive focus:ring-focus-destructive focus:outline-transparent";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TOption = Pick<TSelectOption, "label" | "value">;

export type TOptionKeys<
  TValueKey extends PropertyKey,
  TLabelKey extends PropertyKey,
> = {
  value: TValueKey;
  label: TLabelKey;
};
